module.exports = __webpack_public_path__ + "static/media/mobileAboutTile@2x.b66917c2.svg";